import { RANKING_LAST_VERIFIED_LABEL } from '../data/rankingFreshness';

/** Batch 0 review rules: which pages may show affiliate buttons and trust badges. */

export const GENERAL_CHAT_REVIEW_SLUGS = [
  'character-ai-review',
  'replika-ai-review',
  'polybuzz-ai-review',
  'talkie-ai-review',
] as const;

const TRUST_BADGE_HIDDEN = new Set(['muah-ai-review']);

const TRY_BUTTON_HIDDEN = new Set(['muah-ai-review', 'character-ai-review']);

const EXPERT_PICK_HIDDEN = new Set<string>([
  ...TRUST_BADGE_HIDDEN,
  ...GENERAL_CHAT_REVIEW_SLUGS,
]);

const QUICK_VERDICT_PROS_ONLY = new Set([
  'spicy-chat-ai-review',
  'character-ai-review',
  'replika-ai-review',
]);

export function usesQuickVerdictProsOnly(slug: string): boolean {
  return QUICK_VERDICT_PROS_ONLY.has(slug);
}

export function withPricesCheckedNote(html: string): string {
  if (!html || /Prices checked/i.test(html)) return html;
  const note = `<p class="mb-6 text-sm text-pink-200/70">Prices checked ${RANKING_LAST_VERIFIED_LABEL}.</p>`;
  const pricingIndex = html.search(/id=["']pricing["']/i);
  if (pricingIndex < 0) return html;
  const tableClose = html.indexOf('</table>', pricingIndex);
  if (tableClose < 0) return html;
  const insertAt = tableClose + '</table>'.length;
  return `${html.slice(0, insertAt)}\n${note}${html.slice(insertAt)}`;
}

export function hasPublishedPrice(price: string | undefined): boolean {
  const value = (price || '').trim();
  if (!value) return false;
  if (/to verify/i.test(value)) return false;
  if (/starting at\s*$/i.test(value)) return false;
  if (/starting at(?=\S)/i.test(value)) return false;
  return true;
}

export const hidesReviewTryButton = (slug: string): boolean => TRY_BUTTON_HIDDEN.has(slug);

export const hidesTrustBadges = (slug: string): boolean => TRUST_BADGE_HIDDEN.has(slug);

export const hidesExpertPick = (slug: string): boolean => EXPERT_PICK_HIDDEN.has(slug);

export const isGeneralChatReview = (slug: string): boolean =>
  (GENERAL_CHAT_REVIEW_SLUGS as readonly string[]).includes(slug);

export const generalChatAgeNote = (productName: string, storeRating: string): string =>
  `Age rating: ${productName} is rated ${storeRating} on the US App Store. Heaven Girlfriend is for adults 18+. This review covers ${productName} as a general chat app only.`;

export const EMOTIONAL_SUPPORT_HEALTH_NOTE =
  'AI companions can be fun and comforting, but they are not a substitute for friends, a partner, or professional mental-health care. If you are struggling, please talk to someone you trust or a licensed professional.';
